/*
 *
 * TransactionDetailsNotePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 06-Jun-2025
*/

import TransactionDetailsNotePopup from './TransactionDetailsNotePopupContainer'

export default TransactionDetailsNotePopup
